"use client";
import styled, { css } from "styled-components";
import { breakpointTablet, breakpointDesktop } from "../../utilities/layout/breakpoints.js";
const ParagraphSpacingTypes = [
  "Display",
  "Headline",
  "Subtitle",
  "Overline",
  "Lead"
];
const tuple = (...args) => args;
const HeaderLevels = tuple(...["h1", "h2", "h3", "h4", "h5", "h6"]);
const createTypeSizes = (component, size) => css`
    ${() => {
  const typePrefix = `--moller-type-${size.toLowerCase()}-${component.toLowerCase()}`;
  return css`
            font-family: var(${typePrefix}-font-family);
            font-size: var(${typePrefix}-font-size);
            font-weight: var(${typePrefix}-font-weight);
            line-height: var(${typePrefix}-line-height);
            letter-spacing: var(${typePrefix}-letter-spacing);
            text-decoration: var(${typePrefix}-text-decoration);
            ${component !== "Body" && css`
                margin: 0;
            `};
            ${ParagraphSpacingTypes.includes(component) && css`
                ${TextContainer} &:not(:first-child) {
                    ${createTypeSpacing(component, size)}
                }
            `}
        `;
}}
`;
const createTypeSpacing = (component, size) => css`
    margin-top: var(
        --moller-type-${size.toLowerCase()}-${component.toLowerCase()}-paragraph-spacing
    );
`;
const createDensityTypeSizes = (component, density = "default") => css`
    ${() => {
  const type = `--moller-type-${density.toLowerCase()}-${component.toLowerCase()}`;
  return css`
            font-family: var(${type}-font-family);
            font-size: var(${type}-font-size);
            font-weight: var(${type}-font-weight);
            line-height: var(${type}-line-height);
            letter-spacing: var(${type}-letter-spacing);
            text-decoration: var(${type}-text-decoration);
        `;
}}
`;
const typeSpacingForScreenSize = (size) => css`
    p,
    ul,
    ol {
        ${createTypeSpacing("Body", size)};
    }
`;
const TextContainer = styled.div`
    ${typeSpacingForScreenSize("Small")}

    @media screen and (min-width: ${breakpointTablet}) {
        ${typeSpacingForScreenSize("Medium")}
    }

    @media screen and (min-width: ${breakpointDesktop}) {
        ${typeSpacingForScreenSize("Large")}
    }
`;
const createType = (component) => css`
    ${createTypeSizes(component, "Small")};

    @media screen and (min-width: ${breakpointTablet}) {
        ${createTypeSizes(component, "Medium")};
    }

    @media screen and (min-width: ${breakpointDesktop}) {
        ${createTypeSizes(component, "Large")};
    }
`;
const globalTextStyles = css`
    background-color: var(--moller-color-background);
    color: var(--moller-color-on-background);
    ${createType("Body")}
`;
const DisplayText = styled.h1`
    ${createType("Display")}
`;
const OverlineText = styled.div`
    ${createType("Overline")}
    text-transform: uppercase;
`;
const Headline = styled.h2`
    ${createType("Headline")}

    ${OverlineText} + && {
        margin-top: 0;
    }
`;
const Subtitle = styled.h3`
    ${createType("Subtitle")}
`;
const LeadText = styled.p`
    ${createType("Lead")}
`;
const Link = styled.a`
    ${createType("Link")}
    &, &:visited, &:hover, &:active {
        color: currentColor;
    }
`;
const Description = styled.div`
    ${createType("Description")};
`;
const LabelText = styled.div`
    ${(props) => createDensityTypeSizes("Label", props.density)}
`;
const ActionText = styled.div`
    ${(props) => createDensityTypeSizes("Action", props.density)}
`;
const NoticeText = styled.div`
    ${(props) => createDensityTypeSizes("Notice", props.density)}
    text-transform: uppercase;
`;
export {
  ActionText,
  Description,
  DisplayText,
  HeaderLevels,
  Headline,
  LabelText,
  LeadText,
  Link,
  NoticeText,
  OverlineText,
  Subtitle,
  TextContainer,
  createDensityTypeSizes,
  createType,
  createTypeSizes,
  createTypeSpacing,
  globalTextStyles
};
